import { Typography } from "@mui/material";
import BoxColorWrapper from "./BoxColorWrapper";
import PropTypes from "prop-types";
import { kestoString, pvmString, viikonpv } from "src/components/js/statics1";
import KeikkaIcon2 from "src/components/keikka/keikkaIcon/KeikkaIcon2";
import { useKeikkaData } from "src/context/KeikkaDataContext";
import { useNavData } from "src/context/navContext";

export default function AikaContainer(props) {
  const { doSetTabValue: setTabValue } = useNavData();
  const { keikkaData } = useKeikkaData();

  if (!keikkaData) return <div>Loading AikaContainer...</div>;
  const pvm = pvmString(keikkaData.pumppu.pumppuAika);
  const klo = kestoString(keikkaData.pumppu.pumppuAika, keikkaData.pumppu.pumppuKesto);
  const viikonpvObj = viikonpv(keikkaData.pumppu.pumppuAika);
  const rows = props.rows;

  const styles = {
    aikaContainer: {
      position: "absolute",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 12,
      width: "100%",
      left: 0,
      top: -7,
      paddingRight: 12,
    },
    icon: { position: "absolute", top: -15, left: -3 },
    viikonpv: {
      fontSize: rows > 2 ? "22px" : "18px",
      paddingBottom: rows > 3 ? "7px" : "0px",
    },
  };

  const handleKeikkaIconKlik = (e) => {
    e.stopPropagation();
    setTabValue(0);
  };

  return (
    <>
      <BoxColorWrapper alignItems="center">
        <div className="spaceAround" style={{ width: "100%", paddingRight: "10px" }}>
          <div className="onlyWide" onClick={handleKeikkaIconKlik}>
            <KeikkaIcon2 keikkaData={keikkaData} size={70} />
          </div>
          <div>
            <div style={styles.viikonpv}>
              {viikonpvObj} {pvm}
            </div>
            {rows > 3 && (
              <Typography variant="body" noWrap color="primary">
                {klo}
              </Typography>
            )}
          </div>
        </div>
      </BoxColorWrapper>
    </>
  );
}

AikaContainer.propTypes = {
  rows: PropTypes.number,
};
